/* Styles */
import '@/scss/main.scss';
import '@mdi/font/css/materialdesignicons.css';

import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';

/* Core */
import Vue from 'vue';
import Buefy from 'buefy';
import vuelidate from 'vuelidate';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import VueHtml2pdf from 'vue-html2pdf';
import VueExcelXlsx from "vue-excel-xlsx";


// import VueYouTubeEmbed from 'vue-youtube-embed';
// import VueSanitize from 'vue-sanitize';
import CKEditor from 'ckeditor4-vue';
import VueClipboard from 'vue-clipboard2';
// import './../node_modules/bulma/css/bulma.css';

/* Router & Store */
import router from './router';
import store from './store';

library.add(fas);

/* Service Worker */
import './registerServiceWorker';

/* Vue. Main component */
import App from './App.vue';

Vue.component('vue-fontawesome', FontAwesomeIcon);

/*   Filters from ./filters  */
import filters from './filters';

/* Vue. Component in recursion */
import AsideMenuList from '@/components/AsideMenuList';

import AppSocket from './plugins/socket';
import { getSocketEndpoint, getAllOnlineUserEndpoint } from './helpers';
import vueSanitize from 'vue-sanitize';
// Vue.use(AppSocket, {
//   connection: getSocketEndpoint(),
//   onConnection: getAllOnlineUserEndpoint()
// });

Vue.config.ignoredElements = ['ion-icons', /^ion-/];

/* Collapse mobile aside menu on route change */
router.afterEach(() => {
  store.commit('asideMobileStateToggle', false);
});

Vue.config.productionTip = false;

/* These components are used in recursion algorithm */
Vue.component('AsideMenuList', AsideMenuList);

Vue.use(vuelidate);
Vue.use(CKEditor);
Vue.use(VueClipboard);
// Vue.use(VueHtml2pdf);
Vue.use(VueExcelXlsx);
Vue.use(Buefy, {
  // defaultIconComponent: 'vue-fontawesome'
  defaultIconPack: 'fas'
});
Vue.use(vueSanitize);

filters();

new Vue({
  router,
  store,
  vuelidate,
  render: h => h(App)
}).$mount('#app');
